import { Component, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { NgForm } from '@angular/forms';
import { VcaAlertsService } from '../../../../../common/vca-alerts';
import { AppState } from '../../../../app.service';
import { State } from '@clr/angular';
import { ReplicatedService } from './replicated.service';

@Component({
    selector: 'replication-site',
    providers: [ReplicatedService, TranslateService],
    styles: [require('./replicated-vdc.scss')],
    template: require('./set-replication-destination.html')
})

export class SetReplicationSite {
    @Input() isVisible: boolean;
    @Output('onClose') selfClose = new EventEmitter();
    @ViewChild('modelBody') modelBody: ElementRef;
    @Input() selectedVDC: any;

    private subscription: Subscription;
    private active: boolean = true;
    private isOperationInProgress: boolean = false;
    private loading: boolean = true;
    private sites = [];
    private result: any;
    private selectedSite: any = '0';
    private showError: boolean = false;
    private errorMsg: string = '';
    private defaultSiteOption: any;

    constructor(private alert: VcaAlertsService, public appState: AppState, public translate: TranslateService, public service: ReplicatedService) {
        translate.use(GlobalVariables.LOCALE);
    }

    ngOnInit() {
        this.reset();
        this.getReplicationSites();
    }

    ngOnChanges(changes) {
        if (changes && changes.hasOwnProperty('isVisible') && changes.isVisible
            && changes.isVisible.hasOwnProperty('currentValue')
            && changes.isVisible.currentValue) {
            this.reset();
            this.loading = true;
            this.getReplicationSites();
        }
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    // Work around until form has a reset method
    reset() {
        this.active = false;
        this.sites = [];
        this.selectedSite = '0';
        this.isOperationInProgress = false;
        this.errorMsg = '';
        this.showError = false;
        setTimeout(() => this.active = true, 0);
    }

    onChangeDestinationSite(site) {
        if (site) {
            this.selectedSite = site;
        }
        this.showError = false;
    }

    closeSelf() {
        if (this.selfClose) {
        this.selfClose.emit({
            value: 'close'
        });
        }
    }

    onCancelForm() {
       this.closeSelf();
    }

    onSubmitForm(f: NgForm): void {
        if (f.valid) {
            this.configureDestinationCloud(f.value);
        }
    }

    private configureDestinationCloud(formData) {
        this.isOperationInProgress = true;
        this.subscription = this.service.configureDestinationCloud(this.preparePayloadForRest(formData)).subscribe(
        res => {
            this.isOperationInProgress = false;
            this.closeSelf();
        },
        error => {
            this.isOperationInProgress = false;
            this.errorMsg = error;
            this.showError = true;
        },
        () => this.service.logOperationCompleted('ConfigureDestinationCloud Completed')
        );
    }

    private preparePayloadForRest(formData) {
        let me = this;
        let payloadForSetSite = {};
        if (this.selectedVDC && this.selectedVDC.id && this.sites
                && formData && formData.destinationSite && formData.destinationSite !== '0') {
            this.sites.map(function(item, index) {
                if (formData.destinationSite == item.url) {
                    payloadForSetSite = {
                        siteUrl:  item.siteUrl,
                        siteName: item.siteName,
                        url:  item.url,
                        vdcId:  me.selectedVDC.id
                    };
                }
            });
        }
        return payloadForSetSite;
    }

    getReplicationSites() {
        this.subscription = this.service.getReplicationSites()
        .subscribe(
            result => {
            this.result = result;
            this.processData(this.result);
            },
            error => this.service.logError(error, 'get Replication Sites'),
            () => this.service.logOperationCompleted('get Replication Sites completed')
        );
    }

    processData(res) {
        let me = this;
        this.defaultSiteOption = {
            'siteName': this.translate.instant('dpsModule.replicatedVdc.vdcList.modalDialog.setReplicationSite.fields.destinationSite.placeHolder'),
            'siteUrl': 'destination-site-url',
            'url': '0'
        };
        this.selectedSite = '0';
        this.sites = [];
        this.sites.push(this.defaultSiteOption);
        if (res && res.dpsReplicationSiteList) {
            res.dpsReplicationSiteList.map(function(item, index) {
                me.sites.push(item);
                if( me.selectedVDC &&  me.selectedVDC.replicationSite && me.selectedVDC.replicationSite == item.siteName){
                    me.selectedSite = item.url;
                }
            });

        } else {
            this.selectedSite = '0';
        }
        this.loading = false;
    }

    private onAlertClose() {
      this.showError = false;
   }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-vcd/replicated-vdc/set-replication-destination.component.ts